import { render } from "./MainIndex.vue?vue&type=template&id=eadbe28e&ts=true"
import script from "./MainIndex.vue?vue&type=script&lang=ts"
export * from "./MainIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__